/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Consul Global Network Manager Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2022-02-15
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason;
(function (HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason) {
    HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason["UNDEFINED"] = "INELIGIBILITY_UNDEFINED";
    HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason["MINVERSIONNOTMET"] = "INELIGIBILITY_MIN_VERSION_NOT_MET";
    HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason["PEERINGNOTENABLED"] = "INELIGIBILITY_PEERING_NOT_ENABLED";
    HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason["CROSSCLOUDPREMIUMTIERREQUIRED"] = "INELIGIBILITY_CROSS_CLOUD_PREMIUM_TIER_REQUIRED";
    HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason["CROSSREGIONPLUSTIERREQUIRED"] = "INELIGIBILITY_CROSS_REGION_PLUS_TIER_REQUIRED";
    HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason["NOCONNECTIVITYPOSSIBLE"] = "INELIGIBILITY_NO_CONNECTIVITY_POSSIBLE";
    HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason["INELIGIBLEBILLINGPLAN"] = "INELIGIBILITY_INELIGIBLE_BILLING_PLAN";
    HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason["CLUSTERINVALIDSTATE"] = "INELIGIBILITY_CLUSTER_INVALID_STATE";
    HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason["CONSULACCESSREADONLY"] = "INELIGIBILITY_CONSUL_ACCESS_READ_ONLY";
    HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason["INVALIDLICENSE"] = "INELIGIBILITY_INVALID_LICENSE";
})(HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason || (HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReason = {}));
export function HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReasonFromJSON(json) {
    return HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReasonFromJSONTyped(json, false);
}
export function HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReasonFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HashicorpCloudGlobalNetworkManager20220215PeeringIneligibilityReasonToJSON(value) {
    return value;
}
